import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import { useDispatch, useSelector } from "react-redux";
import { handleListResponse, seo } from "utils/utils";
import { getRaiseTicketList } from "reduxStore/action/raiseTicket(Support)Actions";
import TableDataNotFound from "component/TableDataNotFound";
import {
  MasterTypeHelper,
  raiseTicketStatus,
  raiseTicketStatusColor,
} from "utils/constants";
import moment from "moment";
import usePage from "utils/usePage";
import { getMasterList } from "reduxStore/action/masterActions";
import Pagination from "component/common/Pagination";
import { CallCenter, CPAgent } from "../../utils/constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Select from "react-select";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import raiseTicketSerive from "../../reduxStore/service/raiseTicket(Support)Serivce";

const SupportTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [propertyList, setPropertyList] = useState([]);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [ticketIssue, setTicketIssue] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    search_status: "",
    search_issue: "",
    ticket_number: "",
    search_property_name: "",
  });
  const [getraiseTikcetList, setRaiseTikcetList] = useState([]);

  const ReportListSelector = useSelector((state) => state.report);

  const raiseTikcetListSelector =
    useSelector((state) => state?.raiseTicket) || [];

  const searchIssueSelector = useSelector((state) => state?.masterData) || [];

  const { create, view, edit, update, isAdmin } = usePermission({
    create: "add_raise_ticket",
    view: "support_ticket_details",
    update: "update_ticket_status",
    edit: "edit_raise_ticket",
  });

  const userType = useSelector((state) => {
    const { response } = state?.login;
    if (!isAdmin) {
      return 2;
    } else {
      return 2;
    }
  });

  useEffect(() => {
    if (searchIssueSelector?.response) {
      const { response } = searchIssueSelector;
      if (response?.status === 200) {
        setTicketIssue(response.data);
      } else {
        setTicketIssue([]);
      }
    }
  }, [searchIssueSelector]);

  useEffect(() => {
    if (raiseTikcetListSelector?.response?.status === 200) {
      if (raiseTikcetListSelector?.response?.data?.length > 0) {
        setRaiseTikcetList(
          handleListResponse(raiseTikcetListSelector?.response?.data)
        );
      }
    } else {
      setRaiseTikcetList([]);
    }
  }, [raiseTikcetListSelector]);

  useEffect(() => {
    dispatch(
      getRaiseTicketList({ search_type: userType, limit: 10, offset: page })
    );
    dispatch(getMasterList({ type: MasterTypeHelper.support }));
  }, [dispatch]);

  useEffect(() => {
    const { reportPropertyList } = ReportListSelector;
    if (reportPropertyList) {
      if (reportPropertyList?.status === 200) {
        setPropertyList(handleListResponse(reportPropertyList.data));
      } else {
        setPropertyList([]);
      }
    }
  }, [ReportListSelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getRaiseTicketList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          search_status: form.search_status,
          search_issue: form.search_issue,
          ticket_number: form.ticket_number,
          search_type: userType,
          search_property_name: form?.site?._id,
        })
      );
      setPage(0);
    }
  };

  useEffect(() => {
    dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
  }, [dispatch]);

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      limit: "",
      offset: "",
      search_status: "",
      search_issue: "",
      ticket_number: "",
      search_property_name: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    dispatch(
      getRaiseTicketList({ search_type: userType, limit: 10, offset: 0 })
    );
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getRaiseTicketList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        search_status: form.search_status,
        search_issue: form.search_issue,
        ticket_number: form.ticket_number,
        search_type: userType,
        search_property_name: form?.site?._id,
      })
    );
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Support Ticket Listing",
      metaDescription: "Support ticket listing",
      canonicalLink: window.location.href,
    });
  }, []);

  //Download List data in excel file
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportticketdata = async (apiData, fileName) => {
    try {
      const item = {
        limit: 10,
        offset: 0,
        start_date: form.start_date,
        end_date: form.end_date,
        search_status: form.search_status,
        search_issue: form.search_issue,
        ticket_number: form.ticket_number,
        search_type: userType,
        search_property_name: form?.site?.property_title,
        export: true,
      };
      const res = await raiseTicketSerive.getRaiseTicketList(item);
      if (res.data.status === 200) {
        var customHeadings = res.data.data.map((item) => ({
          "Ticket No.": item.ticket_number,
          "Property Title": item.property_title[0],
          "Ticket Title": item.title,
          Description: item.remark,
          "Create By": item.create_by_name,
          Issue: item.reason_title,
          "Created Date": moment(item.createdDate).format("DD-MM-yyyy hh:mm a"),
          Status: raiseTicketStatus[item.status],
        }));
      } else {
      }
    } catch (e) {}

    const ws = XLSX.utils.json_to_sheet(customHeadings);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.supportRequest}
        parentListing={null}
        titleactive={strings.raiseTicketList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByIssue}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="search_issue"
                            value={form.search_issue}
                            onChange={handleInputField}
                          >
                            <option value="">{strings.selectIssue}</option>
                            {ticketIssue?.length ? (
                              ticketIssue.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="search_status"
                            value={form.search_status}
                            onChange={handleInputField}
                          >
                            <option value="">{strings.selectstatus}</option>
                            <option value={1}>{strings.open}</option>
                            <option value={2}>{strings.close}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByTicketNo}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="number"
                              name="ticket_number"
                              placeholder={strings.searchByTicketNo}
                              value={form.ticket_number}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                        {isAdmin && (
                          <div className="col-md-4">
                            <span className="cardText">
                              {strings.searchByPropertyName}
                            </span>
                            <Select
                              isSearchable
                              isClearable
                              onInputChange={(e) => {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    })
                                  );
                                }
                              }}
                              placeholder={strings.searchByPropertyName}
                              options={propertyList}
                              getOptionLabel={(option) =>
                                `${option.property_title}`
                              }
                              getOptionValue={(option) => option._id}
                              name="site"
                              value={form.site}
                              onChange={(e) => {
                                setForm({ ...form, site: e });
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-12 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {!isAdmin && create && (
              <div className="row pt-3">
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/raise_ticket_form")}
                    >
                      {strings.addRaiseTicket}
                    </button>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/raise_ticket")}
                    >
                      {strings.myTicket}
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-10">
                        <h5>{strings.supportRequest}</h5>
                      </div>
                      {/* <div className="col-md-2">
                        <button
                          className="btn btn-warning mr-4"
                          type="button"
                          onClick={() =>
                            exportticketdata(getraiseTikcetList, "ticket")
                          }
                        >
                          {strings.exportList}
                        </button>
                      </div> */}
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.ticketNo}</th>
                       
                        
                          <th scope="col">{strings.ticket}</th>
                          <th scope="col">{strings.createBy}</th>
                          <th scope="col">{strings.issue}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getraiseTikcetList?.length > 0 ? (
                          getraiseTikcetList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.ticket_number}</td>
                                <td className="text-center">
                                  {item?.title
                                    ? item?.title.length > 20
                                      ? item?.title.substring(0, 20) + "..."
                                      : item?.title
                                    : "-"}
                                </td>
                                <td>{item.create_by_name}</td>
                                <td>{item.reason_title}</td>
                                <td>
                                  {moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a"
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: raiseTicketStatusColor[item?.status],
                                    fontWeight: "600",
                                  }}
                                >
                                  {raiseTicketStatus[item.status]}
                                </td>
                                <td>
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="View Raise Ticket"
                                      onClick={() =>
                                        navigatpage(
                                          `/view_raise_ticket?ticket_id=${item._id}`
                                        )
                                      }
                                    ></i>
                                  )}
                                  {update && (
                                    <i
                                      className="fa fa-refresh theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="Update Status"
                                      onClick={() =>
                                        navigatpage(
                                          `/updatestatus?ticket_id=${item._id}`
                                        )
                                      }
                                    ></i>
                                  )}
                                  {/* {!isAdmin && edit && (
                                    <i
                                      className="fa fa-edit theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="Edit Raise Ticket"
                                      onClick={() =>
                                        navigatpage(
                                          `/raise_ticket_form?ticket_id=${item._id}`
                                        )
                                      }
                                    ></i>
                                  )} */}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getraiseTikcetList} />
                  </div>
                  <Pagination
                    totalCount={raiseTikcetListSelector?.response?.total_data}
                    listData={getraiseTikcetList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupportTicket;
